import { useMyInTransitPolling } from "./Hooks/useMyInTransitPolling";
import { useClipStatusRegistry } from "./Hooks/useClipStatusRegistry";

export const ClipStatusViewModel = () => {
  const {
    inFlightClips,
    pollingActive,
    kickPulsePolling,
    dismissTerminal,
    dismissed,
  } = useMyInTransitPolling();

  const entries = useClipStatusRegistry(inFlightClips, dismissed);

  return {
    entries,
    inFlightClips,
    pollingActive,
    dismissTerminal,
    dismissed,
    kickPulsePolling,
  };
};
